module.exports = __webpack_public_path__ + "cube.svg?b48eba826f2626e19f0bf6aadb404d31";